import { baseApi } from "../../../../app/api";

const CUSTOM_REST_API_BASE =
  window.commonVariables?.customRestApiBase || "/wp-json/ecommerce-app/v1";

export const wishlistApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Fetches the array of product IDs from the backend (Session or User Meta).
     */
    getWishlist: builder.query<number[], void>({
      query: () => ({
        url: `${CUSTOM_REST_API_BASE}/wishlist`,
        method: "GET",
      }),
      providesTags: ["Wishlist"],
    }),

    /**
     * Toggles an item's presence in the wishlist via API.
     */
    toggleWishlistItem: builder.mutation<number[], number>({
      query: (productId) => ({
        url: `${CUSTOM_REST_API_BASE}/wishlist/toggle`,
        method: "POST",
        body: { id: productId },
      }),
      invalidatesTags: ["Wishlist"],
    }),

    /**
     * Explicitly adds an item to the wishlist.
     */
    addWishlistItem: builder.mutation<
      number[],
      { productId: number; parentId: number }
    >({
      query: ({ productId, parentId }) => {
        const idToAdd = parentId > 0 ? parentId : productId;
        return {
          url: `${CUSTOM_REST_API_BASE}/wishlist/add`,
          method: "POST",
          body: { id: idToAdd },
        };
      },
      invalidatesTags: ["Wishlist"],
    }),

    /**
     * Explicitly removes an item from the wishlist.
     */
    removeWishlistItem: builder.mutation<number[], number>({
      query: (productId) => ({
        url: `${CUSTOM_REST_API_BASE}/wishlist/${productId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Wishlist"],
    }),
  }),
});

export const {
  useGetWishlistQuery,
  useToggleWishlistItemMutation,
  useAddWishlistItemMutation,
  useRemoveWishlistItemMutation,
} = wishlistApi;
